import { Form, Row, Col } from "react-bootstrap";
import type { LocationFormValues } from "../types";

export interface LocationFormProps {
  values: LocationFormValues;
  onChange: (next: LocationFormValues) => void;
}

export const LocationForm = ({
  values,
  onChange,
}: LocationFormProps): JSX.Element => {
  const set = <K extends keyof LocationFormValues>(
    key: K,
    v: LocationFormValues[K]
  ) => onChange({ ...values, [key]: v });

  return (
    <Form>
      <Row>
        <Col sm={6}>
          <Form.Group className="mb-3">
            <Form.Label htmlFor="location-name">Name</Form.Label>
            <Form.Control
              id="location-name"
              type="text"
              required
              placeholder="Main Office"
              value={values.name}
              onChange={(e) => set("name", e.target.value)}
            />
          </Form.Group>
        </Col>
        <Col sm={6}>
          <Form.Group className="mb-3">
            <Form.Label htmlFor="location-street">Street</Form.Label>
            <Form.Control
              id="location-street"
              type="text"
              placeholder="123 Main St"
              value={values.street}
              onChange={(e) => set("street", e.target.value)}
            />
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <Form.Group className="mb-3">
            <Form.Label htmlFor="location-street2">Street 2</Form.Label>
            <Form.Control
              id="location-street2"
              type="text"
              placeholder="Suite 100"
              value={values.street2}
              onChange={(e) => set("street2", e.target.value)}
            />
          </Form.Group>
        </Col>
        <Col sm={6}>
          <Form.Group className="mb-3">
            <Form.Label htmlFor="location-city">City</Form.Label>
            <Form.Control
              id="location-city"
              type="text"
              placeholder="New York"
              value={values.city}
              onChange={(e) => set("city", e.target.value)}
            />
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <Form.Group className="mb-3">
            <Form.Label htmlFor="location-state">State</Form.Label>
            <Form.Control
              id="location-state"
              type="text"
              placeholder="NY"
              value={values.state}
              onChange={(e) => set("state", e.target.value)}
            />
          </Form.Group>
        </Col>
        <Col sm={6}>
          <Form.Group className="mb-3">
            <Form.Label htmlFor="location-postal-code">Postal Code</Form.Label>
            <Form.Control
              id="location-postal-code"
              type="text"
              placeholder="10001"
              value={values.postalCode}
              onChange={(e) => set("postalCode", e.target.value)}
            />
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <Form.Group className="mb-3">
            <Form.Label htmlFor="location-country">Country</Form.Label>
            <Form.Control
              id="location-country"
              type="text"
              placeholder="US"
              value={values.country}
              onChange={(e) => set("country", e.target.value)}
            />
          </Form.Group>
        </Col>
      </Row>
    </Form>
  );
};

export default LocationForm;
